import { normalizeValue } from './ValueNormalizer';

export const SuspensionType = ['HYD', 'MEC', 'PME'] as const;

export const normalizeSuspensionType = (
  type?: string | null,
): string | undefined => {
  return normalizeValue(SuspensionType, type);
};
